export const SketchOrderDeliveryOptionValues = [
    {key: "Don't send sketch report", value: 'OmitSketchReport'}
];
